// extracted by mini-css-extract-plugin
export var body = "_oa-8";
export var button = "_oa-0";
export var closeButton = "_oa-5";
export var content = "_oa-3";
export var empty = "_oa-f";
export var grid = "_oa-c";
export var header = "_oa-4";
export var icon = "_oa-1";
export var option = "_oa-d";
export var optionSelected = "_oa-e";
export var overlay = "_oa-2";
export var searchIcon = "_oa-a";
export var searchInput = "_oa-b";
export var searchWrapper = "_oa-9";
export var title = "_oa-6";
export var visuallyHidden = "_oa-7";